import { useTranslation } from 'react-i18next'

import useReturnPortalFeatures from '@/common/hooks/useReturnPortalFeatures/useReturnPortalFeatures'
import {
  getNotesAndImagesVisibility,
  getReturnReasonsSettingsPayload,
  getSortingValue,
} from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonsSettingsConfiguration/helpers'
import { notesAndImagesVisibilityValues } from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonsSettingsConfiguration/RejectedProductsSection/constants'

const useReturnReasonsSettings = ({ returnPortalId, setToastInfo }) => {
  const { t } = useTranslation()
  const {
    returnPortalFeatures,
    refetchReturnPortalFeatures,
    fetchingReturnPortalFeatures,
    editReturnPortalPreferences,
    editingReturnPortalPreferences,
    setReturnPortalFeatures,
    hasReturnPortalFeaturesChanges,
    resetReturnPortalFeatures,
  } = useReturnPortalFeatures({ returnPortalId })

  const onChangePreference = (field, value) => {
    setReturnPortalFeatures(prevData => ({ ...prevData, [field]: value }))
  }

  const setShowRejectedNotesAndImages = value => {
    onChangePreference('show_rejected', value === notesAndImagesVisibilityValues.visible)
  }

  const setReturnReasonsSorting = value => onChangePreference('return_reasons_sorting', value)

  const setReturnSubreasonsSorting = value => onChangePreference('return_subreasons_sorting', value)

  const onSave = async () => {
    try {
      await editReturnPortalPreferences({
        returnPortalId,
        payload: getReturnReasonsSettingsPayload(returnPortalFeatures),
      })
      await refetchReturnPortalFeatures()
      setToastInfo({ show: true, message: t('Cambios guardados'), type: 'success' })
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    loading: fetchingReturnPortalFeatures,
    saving: editingReturnPortalPreferences,
    hasChanges: hasReturnPortalFeaturesChanges,
    revertChanges: resetReturnPortalFeatures,
    showRejectedNotesAndImages: getNotesAndImagesVisibility(returnPortalFeatures?.show_rejected),
    returnReasonsSorting: getSortingValue(returnPortalFeatures?.return_reasons_sorting),
    returnSubreasonsSorting: getSortingValue(returnPortalFeatures?.return_subreasons_sorting),
    setShowRejectedNotesAndImages,
    setReturnReasonsSorting,
    setReturnSubreasonsSorting,
    onSave,
  }
}

export default useReturnReasonsSettings
